import ProjectPropertyUpdateModal from "./ProjectPropertyUpdateModal"

export default ProjectPropertyUpdateModal
